type CheckoutPricingSnapshot = {
  priceId: string;
  currencyCode: string;
  dueTodayAmount: number;
  recurringAmount: number;
} | null;

type PricingListener = () => void;

let pricing: CheckoutPricingSnapshot = null;
const listeners = new Set<PricingListener>();

export const checkoutPricingStore = {
  getPricing(): CheckoutPricingSnapshot {
    return pricing;
  },

  setPricing(snapshot: NonNullable<CheckoutPricingSnapshot>): void {
    pricing = snapshot;
    listeners.forEach((listener) => listener());
  },

  subscribe(listener: PricingListener): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};
